import api from '../../REST/api';
import createExportDump from '../../utils/create-export-dump';

const dump = createExportDump(api.exportCampaigns, 'status', 'campaigns');

export default dump;
